/**
 * Format a quantity stored in base units (kg, ml, g, etc.) for display.
 * The database stores everything in kg for weight-based materials,
 * but materials may have display unit "ton" (1 ton = 1000 kg).
 *
 * This converts the stored value to the material's display unit.
 */
export function formatQty(qty: number, unit?: string): string {
  if (unit === "ton" || unit === "tonne") {
    return (qty / 1000).toLocaleString(undefined, { maximumFractionDigits: 3 });
  }
  return qty.toLocaleString(undefined, { maximumFractionDigits: 3 });
}

/**
 * Format a rate stored in per-base-unit (per kg) for display.
 * If display unit is "ton", multiply by 1000 to show per-ton rate.
 */
export function formatRate(rate: number, unit?: string): string {
  if (unit === "ton" || unit === "tonne") {
    return (rate * 1000).toLocaleString(undefined, { maximumFractionDigits: 2 });
  }
  return rate.toLocaleString(undefined, { maximumFractionDigits: 2 });
}

/**
 * Get the display unit label.
 */
export function displayUnit(unit?: string): string {
  if (unit === "ton" || unit === "tonne") return "ton";
  return unit || "";
}
